import * as React from 'react';
import Link from 'next/link';
import { Tag } from '../../utils/schema';
import { Alink, TagsWrapper } from './index.style';

interface ArticleTagsProps {
  tags: Tag[];
}

const ArticleTags = ({ tags }: ArticleTagsProps) => (
  <TagsWrapper>
    Tags:{' '}
    {tags.map((tag, index) => (
      <React.Fragment key={tag.id}>
        <Link as={`/inspire/tag/${tag.slug}`} href={`/tag?tag=${tag.slug}`} passHref>
          <Alink target="_blank">{tag.name}</Alink>
        </Link>
        {index < tags.length - 1 ? ', ' : ''}
      </React.Fragment>
    ))}
  </TagsWrapper>
);

export default ArticleTags;
